import store from '@/store'
import axios from 'axios'

export default {

  async  getConfigs () {
    try {
      let result = await axios.get(store.getters.getMembershipApi + '/membership/config/' + store.state.company.companyId)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao obter configurações de fidelidade'}
      }  
    } catch (e) {
      let error = {e} 
      console.log(error) 
      return { error: true, data: error, msg: 'Erro ao obter configurações de fidelidade'} 
    }
  },

  async getNfeList () {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.get(store.getters.getMembershipApi + '/membership/users/nfe-list', headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao obter lista de notas'}
      }  
    } catch (e) {
      let error = {e} 
      console.log(error) 
      return { error: true, data: error, msg: 'Erro ao obter lista de notas'} 
    }
  },

  async savePointsByNfe (points) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.put(store.getters.getMembershipApi + '/membership/users/admin/transaction_log/offline', points, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao atribuir pontos'}
      }  
    } catch (e) {
      let error = {e} 
      console.log(error) 
      return { error: true, data: error, msg: 'Erro ao atribuir pontos'} 
    }
  },

  async saveConfigs (config) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.put(store.getters.getMembershipApi + '/membership/config/', config, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null, msg: 'Erro ao salvar configurações de fidelidade'}
      }  
    } catch (e) {
      let error = {e} 
      console.log(error) 
      return { error: true, data: error, msg: 'Erro ao salvar configurações de fidelidade'} 
    }
  },

  async getOrderList () {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.get(store.getters.getMembershipApi + '/membership/orders', {}, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e} 
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao obter resgates'}
    }
  },

  async updateOrderStatus (orderId, status) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.patch(store.getters.getMembershipApi + '/membership/orders/' + orderId + '/status',
       { status: status }, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e} 
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao atualizar order'}
    }
  },

  async getPrizes () {
    try {
      let result = await axios.get(store.getters.getMembershipApi + '/membership/prizes/' + store.state.company.companyId)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e}
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao obter prêmios'}
    }
  },

  async savePrize (prize) {
    try {
      let jwt = localStorage.getItem('jwt')
      let headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': jwt
      }
      let result = await axios.put(store.getters.getMembershipApi + '/membership/prizes',
       prize, headers)
      if (result.data) {
        return result.data
      } else {
        return {error: true, data: null}
      }
    } catch (e) {
      let error = {e} 
      console.log('error', error.e)
      return { error: true, code: 500, msg:'Erro ao atualizar order'}
    }
  }

}